import BatchesContainer from "./container";

export default BatchesContainer;
